module.exports = __webpack_public_path__ + "static/media/arrow-right_dark.2767435f.svg";